<template>
  <RegisterPage :errors="errors" is-company :title="$t('Create a client account')">
    <template #left>
      <LeftRegisterCompany />
    </template>

    <template #inputs-hidden>
      <input type="hidden" name="account_type" value="company" />
    </template>
  </RegisterPage>
</template>

<script>
import LeftRegisterCompany from '@/components/auth/left/LeftRegisterCompany.vue'
import RegisterPage from '@/components/auth/RegisterPage.vue'

export default {
  name: 'RegisterCompanyPage',
  components: {
    LeftRegisterCompany,
    RegisterPage,
  },
  props: {
    errors: {
      type: Object,
      required: true,
    },
  },
}
</script>
